"use strict";

var _taggedTemplateLiteral = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextButton = exports.PrevButton = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var getNextArrow = function getNextArrow(color) {
  return "url(\"data:image/svg+xml,%3Csvg width='19' height='30' viewBox='0 0 19 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.475037 26.475L11.925 15L0.475037 3.525L4.00004 0L19 15L4.00004 30L0.475037 26.475Z' fill='".concat(encodeURIComponent(color), "'/%3E%3C/svg%3E%0A\")");
};

var getPrevArrow = function getPrevArrow(color) {
  return "url(\"data:image/svg+xml,%3Csvg width='19' height='30' viewBox='0 0 19 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.525 3.525L7.07496 15L18.525 26.475L15 30L-3.8147e-05 15L15 0L18.525 3.525Z' fill='".concat(encodeURIComponent(color), "'/%3E%3C/svg%3E%0A\")");
};

var Button = styled_components_1.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  width: 20px;\n  height: 50px;\n  position: absolute;\n  top: calc(50% - 25px);\n  background-position: center center;\n  background-size: contain;\n  background-repeat: no-repeat;\n"])));
exports.PrevButton = (0, styled_components_1.default)(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  left: -35px;\n  background-image: ", ";\n\n  &:disabled {\n    background-image: ", ";\n  }\n"])), function (_ref) {
  var color = _ref.color;
  return getPrevArrow(color);
}, function (_ref2) {
  var disabledColor = _ref2.disabledColor;
  return getPrevArrow(disabledColor);
});
exports.NextButton = (0, styled_components_1.default)(Button)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  right: -35px;\n  background-image: ", ";\n\n  &:disabled {\n    background-image: ", ";\n  }\n"])), function (_ref3) {
  var color = _ref3.color;
  return getNextArrow(color);
}, function (_ref4) {
  var disabledColor = _ref4.disabledColor;
  return getNextArrow(disabledColor);
});